/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {

	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="wwwy.outube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		}
	});

	// Add equal heights to partners text blocks on Home page - Reuben (24/08/2020)
	var maxHeight = 0;
	for(i=0;i<jQuery("#partners .wp-block-group__inner-container h3 + p").length;i++) {
		if(jQuery("#partners .wp-block-group__inner-container h3 + p").eq(i)) {
			var currentHeight = jQuery("#partners .wp-block-group__inner-container h3 + p").eq(i).height();
			if(currentHeight>=maxHeight){
				maxHeight = currentHeight;
			}
		}
		else {
			break;
		}
	}
	jQuery("#partners .wp-block-group__inner-container h3 + p").height(maxHeight);

	// Read more/read less on team mebers
	jQuery('.team-member .read-more').click(function(e) {
		e.preventDefault();
		var txt = jQuery(this).closest('.text-wrap').next('.toggle-bio').is(':visible') ? 'Read more' : 'Read less';
		jQuery(this).text(txt);
		jQuery(this).closest('.text-wrap').next('.toggle-bio').slideToggle(500);
	});
});
